/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfacebookdescription2Inputs */

const en_crosspostingfacebookdescription2 = /** @type {(inputs: Crosspostingfacebookdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a Facebook page post, reel, or story.`)
};

const de_crosspostingfacebookdescription2 = /** @type {(inputs: Crosspostingfacebookdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen Facebook-Seitenbeitrag, ein Reel oder eine Story.`)
};

/**
* | output |
* | --- |
* | "Create a Facebook page post, reel, or story." |
*
* @param {Crosspostingfacebookdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfacebookdescription2 = /** @type {((inputs?: Crosspostingfacebookdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfacebookdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfacebookdescription2(inputs)
	return de_crosspostingfacebookdescription2(inputs)
});
export { crosspostingfacebookdescription2 as "crosspostingFacebookDescription" }